export{a as addIcons}from"./utils-d6d6c83d.js";import"./index-cb2fa58f.js";